import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
// The focus system, imported here rather than in a component because it is a
// property of the whole document: every interactive element on every screen,
// including the sign-in screen a signed-out visitor sees. See `focus.css` —
// the mock ships no focus affordance at all and this is the replacement.
import './focus.css'

/**
 * The mount point, and the only module in this package with a side effect at
 * import time. Everything else exports and is imported; this one runs.
 *
 * It throws rather than returning quietly when `#root` is missing. A blank
 * white page with nothing in the console is the single hardest front-end
 * failure to diagnose, and the only way `#root` goes missing is that somebody
 * edited `index.html`.
 */
const container = document.getElementById('root')
if (!container) {
  throw new Error('main.tsx: no #root element in index.html — the SPA has nothing to mount into')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
